import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {Payment} from '../../graphql/payments.datatypes';

export const gqlTransferPayment = `
    id
    timestamp
    amount
    payment_type
    payment_status
    billing_party_member_id
    billing_party_amount
    assignedAmount
    description
    provider_reference
    provider_status
    provider_response_raw
    refunds_amount

    billingPartyMember {
        id
        billing_party_id
        is_group_leader
        first_name
        last_name
        email
    }

    groupMemberPayments {
        id
        group_member_id
        amount
        groupMember {
            first_name
            last_name
        }
    }
`;

interface TransfersData {
    transfersInMyGroup: {
        data: Payment[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_TRANSFERS_IN_MY_GROUP_QUERY = gql`
    query transfersInMyGroup($groupRef: String!, $billingPartyId: Int!, $count: Int!, $page: Int!){
        transfersInMyGroup(groupRef: $groupRef, billingPartyId: $billingPartyId, first: $count, page: $page){
            data {
                ${gqlTransferPayment}
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getTransfersInMyGroup = (groupRef: string, billingPartyId: number, count: number, page: number) => useQuery<TransfersData>(
    GET_TRANSFERS_IN_MY_GROUP_QUERY,
    {
        variables: {
            groupRef,
            billingPartyId,
            count,
            page,
        },
    }
);

export default getTransfersInMyGroup;
